// src/services/paths/robotPath/turnRadius.ts
// The robot's turn radius per wheel type — the numbers the robot's own mapper
// drives with, so anything missioncontrol predicts matches the driven path.
// (Moved here when services/paths/dubins/ was deleted.)

export const TURN_RADIUS_M_WHEELS = 5;
export const TURN_RADIUS_M_TRACK = 8;

export const WHEEL_TYPE_OPTIONS = ['wheels', 'track'] as const;
export type WheelType = (typeof WHEEL_TYPE_OPTIONS)[number];

export function resolveTurnRadius(wheelType: WheelType): number {
  return wheelType === 'track' ? TURN_RADIUS_M_TRACK : TURN_RADIUS_M_WHEELS;
}
